import { preloadImage } from '@mail/3promo';
import vkLogo from 'img/vkmusic-bundle/vk-logo.png';
import trialDarkImage from 'img/vkmusic-bundle/vkmusic-bundle-modal/trial/dark.png';
import trialLightImage from 'img/vkmusic-bundle/vkmusic-bundle-modal/trial/light.png';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { VkMusicBundleModalProps } from './VkMusicBundleModal';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderVkMusicBundleModal = (data: VkMusicBundleModalProps) => {
    openPopupHelper({
        popupName: popupNames.VK_MUSIC_BUNDLE_MODAL,
        data,
        onClose: data.onClose,
    });
};

export const closeVkMusicBundleModal = () => closePopupHelper(popupNames.VK_MUSIC_BUNDLE_MODAL);

export const getVkMusicBundleModalCoverImageUrl = (isDarkTheme: boolean) => {
    return isDarkTheme ? trialDarkImage : trialLightImage;
};

export const preloadCover = async () => {
    const coverImageUrl = getVkMusicBundleModalCoverImageUrl(isDarkThemeModeEnabled());
    await preloadImage({ src: coverImageUrl, timeout: IMAGE_PRELOAD_TIMEOUT });
    await preloadImage({ src: vkLogo, timeout: IMAGE_PRELOAD_TIMEOUT });
};
